import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';

interface Props {
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  isReadOnly: boolean;
}

const StoryListToggle = ({ value, onChange, isReadOnly }: Props) => {
  const [loading, setLoading] = useState(false);

  const onToggle = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isReadOnly) {
      return;
    }
    setLoading(true);
    await onChange(event, !value);
    setLoading(false);
  };

  return (
    <div>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <Switch
          size="small"
          checked={value}
          onChange={onToggle}
          onClick={(event) => event.stopPropagation()}
          disabled={isReadOnly}
        />
      )}
    </div>
  );
};

export default StoryListToggle;
